<template>
    <!--会员卡类别-->
    <el-select :multiple="multiple" :clearable="clearable" :value-key="type=='object'?'dicCode':''" :disabled="disabled"
               :value="value" @visible-change="visiblechange" @change="change" :size="size" :placeholder="placeholder">
        <el-option
                v-for="item in list"
                :key="item.dicCode"
                :label="item.dicName"
                :value="type=='object'?item:item.dicCode">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "card-state-code",
        props: {
            size: String,
            placeholder: String,
            multiple: Boolean,
            disabled: Boolean,
            clearable: Boolean,
            value: [Array, Object, String],
            type: String
        },

        model: {
            prop: 'value'
        },
        data() {
            return {
                list: [],
                data: '',
            }
        },
        watch: {
            value(newval, oldval) {
                var code = this.type == 'object' ? newval.dicCode : newval;
                var list = this.list.filter((item) => item.dicCode == code);
                //数据不存在时
                if (list.length == 0) {
                    this.$store.state.dicChange = true;
                    this.getData();
                }

            }
        },
        mounted() {
            this.getData();

        },
        methods: {

            getData() {
                if (this.$root.getStorage('dic')) {
                    this.list = this.$root.getStorage('dic').filter((item) => item.dicType == 'card_state');
                } else {
                    this.$store.state.dicChange = true;
                }
            },

            visiblechange(isshow) {
                if (isshow) {
                    // this.getData();
                }
            },
            change(value) {
                console.log(value)
                this.$emit('input', value)

            }
        }
    }
</script>